
import { readFromFile } from "../../shared.js";
let isA = false; // Initial state of the prompt A/B toggle button // Note that we tried this instruction in the prompt but it only worked when presented in-line with the rest of the chat, as below
//var systemPromptA = !(typeof _systemPromptA === 'undefined')  ? _systemPromptA : await readFromFile("../../../data/systemPrompts/promptA.txt");
export const showAB = true; // Set this flag to control the visibility of the A/B prompt toggle button

import $ from 'jquery';

const toggleBtn = $("#toggle-btn");

export function initAB() {
  
  // Set up the A/B test toggle button for the prompt
  if (toggleBtn.length && showAB) {
    toggleBtn.show();
  }

  toggleBtn.on("click", function () {
    isA = !isA;
    toggleBtn.text(isA ? "A" : "B");
    restartWithNewPrompt();
  });

}

function restartWithNewPrompt() {
  // TODO when we get this feature working again, chatConfig will have to be initialized in its own module,
  // which is imported here.  Since this feature is under construction atm, I'm leaving this commented out.
  // systemPrompt = isA ? systemPromptA : ChatConfig.systemPrompt;
  
  // TODO when we get this functionality working again, startup will have to go into its own module,
  // which is imported here, and also imported from main.js, to avoid a circular dependency.
  // Since this feature is under construction atm, I'm leaving this commented out.
  // startUp();
}

export function switchPrompt() {
      var promptName = isA ? "A" : "B";
      var switchMessage = `Restarting conversation with prompt ${promptName}`;
      appendMessage(switchMessage, "assistant");
      sendSlackMessage(switchMessage);


}